import Chart from "chart.js/auto";
import ChartDataLabels from "chartjs-plugin-datalabels";
import createElementCanvas from "./createElementCanvas.js";

const renderChartPairOfTypes = (type, labels, data, backgroundColor, id) => {
  return new Promise((resolve, reject) => {
    const ctx = createElementCanvas(id, "chart-container");
    const axisTickStep = 11;
    new Chart(ctx, {
      type: type,
      plugins: [ChartDataLabels],
      data: {
        labels: labels,
        datasets: [
          {
            data: data,
            backgroundColor: backgroundColor,
            borderWidth: 1,
          },
        ],
      },
      options: {
        devicePixelRatio: 1.5,
        aspectRatio: 0,
        responsive: true,
        plugins: {
          legend: {
            display: false,
          },
          datalabels: {
            formatter: (value, ctx) => {
              const maxAnswearPoints = 70;
              var percentage =
                ((value / maxAnswearPoints) * 100).toFixed(1) + "%";
              return percentage;
            },
            anchor: "end",
            align: "top",
            offset: 3,
            labels: {
              value: {
                color: "black",
              },
            },
          },
        },
        scales: {
          x: {
            beginAtZero: true,
          },
          y: {
            min: 0,
            max: 70,
            reverse: false,
            beginAtZero: true,
            title: {
              display: true,
              text: "Punkty",
            },
            ticks: {
              count: axisTickStep,
            },
          },
          right: {
            beginAtZero: true,
            title: {
              display: false,
            },
            ticks: {
              display: false,
            },
          },
        },
        animation: {
          duration: 0,
          onComplete: function () {
            resolve();
          },
        },
      },
    });
  });
};

export default renderChartPairOfTypes;
